import { createFileRoute } from "@tanstack/react-router";
import { Card, PageHeading } from "@/ui";
import {
  CliInstall,
  ExamplePrompts,
  McpConnectLede,
  McpInstall,
  McpUseCases,
} from "@/components/developer/McpInstallOptions";
import { ConnectedAgents } from "@/components/developer/ConnectedAgents";

// Developer > MCP & CLI (#728, split off the combined "MCP & API" page —
// #641 originally landed the MCP server/CLI/use-cases cards
// on `developer/access.tsx`; the API-key + API-reference cards stayed there,
// these three moved here). See
// `goodsender-autopilot/specs/728-dashboard-nav-reorg/DECISIONS.md` D-728-3.
export const Route = createFileRoute("/dashboard/w/$workspaceId/developer/mcp")({
  component: DeveloperMcp,
});

function McpServerCard({ workspaceId }: { workspaceId: string }) {
  return (
    <Card title="MCP">
      <McpInstall workspaceId={workspaceId} />
    </Card>
  );
}

// Revocable OAuth connections (directory compliance — web OAuth hardening):
// placed straight after the MCP card, since every row here was created by
// following that card's instructions.
function ConnectedAgentsCard({ workspaceId }: { workspaceId: string }) {
  return (
    <Card title="Connected agents">
      <ConnectedAgents workspaceId={workspaceId} />
    </Card>
  );
}

function CliCard({ workspaceId }: { workspaceId: string }) {
  return (
    <Card title="CLI">
      <CliInstall workspaceId={workspaceId} />
    </Card>
  );
}

function ExamplePromptsCard() {
  return (
    <Card title="Example prompts">
      <ExamplePrompts />
    </Card>
  );
}

function UseCasesCard() {
  return (
    <Card title="What this looks like in practice">
      <McpUseCases />
    </Card>
  );
}

export function DeveloperMcpPage({ workspaceId }: { workspaceId: string }) {
  return (
    <div className="flex flex-col gap-6">
      <PageHeading
        title="MCP & CLI"
        lede={<McpConnectLede workspaceId={workspaceId} />}
      />

      <McpServerCard workspaceId={workspaceId} />
      <ConnectedAgentsCard workspaceId={workspaceId} />
      <CliCard workspaceId={workspaceId} />
      <ExamplePromptsCard />
      <UseCasesCard />
    </div>
  );
}

function DeveloperMcp() {
  const { workspaceId } = Route.useParams();
  return <DeveloperMcpPage workspaceId={workspaceId} />;
}
